/** Shared wording for the library, so a count reads the same everywhere. */

export function trackCountLabel(count: number): string {
  return count === 1 ? '1 song' : `${count} songs`
}
